import axios from "./axiosInstance";

const aboutUsApi = {
  details: () => axios.post("about-us"),
};

export default aboutUsApi;
